import { useId } from 'react';

import FormInput from '../../../app/shared/components/FormInput';
import PricelistFormState from './PricelistFormState';

interface PricelistFormProps {
  state: PricelistFormState;
}

const PricelistForm = ({ state }: PricelistFormProps) => {
  const id = useId();

  return (
    <>
      <FormInput
        id={`${id}-name`}
        name="name"
        label={state.translation.name.label}
        placeholder={state.translation.name.placeholder}
        input={state.name}
      />
      <FormInput
        id={`${id}-description`}
        name="description"
        label={state.translation.description.label}
        placeholder={state.translation.description.placeholder}
        input={state.description}
      />
    </>
  );
};

export default PricelistForm;
